<p-toast></p-toast>
<div *ngIf="openPdfPreviewModal">
  <app-pdf-preview [resourceUrl]="readOnlyFileUrl" [isPdfPreviewModalShow]="openPdfPreviewModal" 
  (showPdfPreviewModal)="showPdfPreviewModal($event)">
  </app-pdf-preview>
</div>
<div class="ml-2">
  <bpt-search
  appBlurOnSearch
  *ngIf="isMasterDataLoaded"
    class="search-component"
    [placeholder]="placeHolder"
    [errorText]="errorText"
    [advancedSearch]="true"
    [searchControls]="searchControl"
    [search]="getSearchResults"
    [advancedSearchMethod]="getAdvancedSearchResults"
  >
  </bpt-search>
</div>

<div *ngIf="hasUserSearched && isPanelHubDataAvailable && !spinnerOn" class="document-panel-hub-container">
  <app-panel-hub 
    #panelHub
    [config]="panelHubConfig" 
    [pagedData]="pagedData"
    [activeView]="currentView"
    (panelHubStateChanged)="onPanelHubStateChanged($any($event))"
    (panelEventHub)="onPanelEventHubInitialized($any($event))"
    (viewChanged)="onViewChanged($any($event))"
    (exportClicked)="onExportClicked()">`
    
    <!-- Header Template (Collapsed View) - Uses named reference for reliable identification -->
    <ng-template #headerTemplate let-data="dataVar">
      <div class="card">
        <div class="card-container">
          <div class="flex">
            <div class="overflow-ellipse flex-initial flex underline document-header font-semibold">
              <div *ngIf="data?.phase !== '8'">
                <em class="blue-color cursor-pointer" (click)="downloadSourceFile(data.documentNumber, data.version, data.phase, data.printLock ?? false)">
                  <em class="fa-solid fa-file fileIconStyle"></em>
                </em>
              </div>
              <b pTooltip="{{data.documentNumber}} {{data.title}} (v{{data.version}})">
                <a style="cursor: pointer;" (click)="openDocument(data?.documentNumber, data?.version?.toString())">
                  {{ data?.documentNumber }} {{ (data?.title?.length > 90) ? (data?.title | slice:0:90) + '..' : data?.title }} (v{{ data?.version }})
                </a>
              </b>
            </div>
            <div class="flex-initial flex justify-content-center font-semibold icon-alignment">
              <b><i class="pi pi-circle-fill green-button" [ngClass]="calculatePhaseColor(data.phase)"></i></b> &nbsp;
              <div class="iconAlignment">
                {{ displayPhaseLabelWithDate(data?.phase, data.effectiveDate, data.requestedEffectiveDate) }}
              </div>
              <span class="fa fa-lightbulb btnBlueColored ml-2" pTooltip="Change Request History" *ngIf="data?.changeRequestItemsCount > 0"></span>
              <span class="notificationSectionCount_Badge" pTooltip="Change Request History" *ngIf="data?.changeRequestItemsCount > 0">
                {{ data?.changeRequestItemsCount }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <!-- Content Template (Expanded View) - Uses named reference for reliable identification -->
    <ng-template #contentTemplate let-data="dataVar" let-viewMode="currentView">
      <!-- Default View -->
      <div class="grid" *ngIf="viewMode === 0">
        <div class="col-fixed" style="width: 15%">
          <div class="font-semibold mb-1">Legacy Document #</div>
          <div class="content-wrap">{{ data?.legacyDocumentNumber }}</div>
        </div>
        <div class="col-fixed" style="width: 12%">
          <div class="font-semibold mb-1">Next Review Date</div>
          <div class="content-wrap">{{ data?.nextReviewDate | date:'dd-MMM-yyyy' }}</div>
        </div>
        <div class="col-fixed" style="width: 14%">
          <div class="font-semibold mb-1">Sub-BU</div>
          <div class="content-wrap">{{ data?.responsibleSubBU }}</div>
        </div>
        <div class="col-fixed" style="width: 14%">
          <div class="font-semibold mb-1">Category</div>
          <div class="content-wrap">
            {{ data?.category }}<br *ngIf="data?.category && data?.localCategory">{{ data?.localCategory }}
          </div>
        </div>
        <div class="col-fixed" style="width: 14%">
          <div class="font-semibold mb-1">Type</div>
          <div class="content-wrap">
            {{ data?.documentType }}<br *ngIf="data?.documentType && data?.localType">{{ data?.localType }}
          </div>
        </div>
        <div class="col-fixed" style="width: 14%">
          <div class="font-semibold mb-1">Assigned Admin(s)</div>
          <div [pTooltip]="calculateToolTip(data?.assignedAdmins)">
            <div *ngFor="let admin of data?.assignedAdmins?.slice(0, 3)" class="content-wrap" 
                 [ngClass]="{'inActiveGroup': admin?.isActive === false || admin?.isTerminated === true}">
              {{ admin?.name }}
            </div>
            <div *ngIf="data?.assignedAdmins?.length > 3">...</div>
          </div>
        </div>
        <div class="col-fixed" style="width: 17%">
          <div class="font-semibold mb-1">eQMS Scope</div>
          <div class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">{{ scope }}</div>
        </div>
      </div>

      <!-- Assignment View -->
      <div class="grid" *ngIf="viewMode === 1">
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Author</div>
          <div class="content-wrap" [ngClass]="{'inActiveGroup': data?.isAuthorTerminated === true}">
            {{ data?.author }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Assigned Admin(s)</div>
          <div [pTooltip]="calculateToolTip(data?.assignedAdmins)">
            <div *ngFor="let admin of data?.assignedAdmins?.slice(0, 3)" class="content-wrap"
                 [ngClass]="{'inActiveGroup': admin?.isActive === false || admin?.isTerminated === true}">
              {{ admin?.name }}
            </div>
            <div *ngIf="data?.assignedAdmins?.length > 3">...</div>
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Collaborator(s)</div>
          <div *ngFor="let collaborator of data?.collaborators" class="content-wrap"
               [ngClass]="{'inActiveGroup': collaborator?.isActive === false || collaborator?.isTerminated === true}">
            {{ collaborator?.name }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Assigned QA(s)</div>
          <div>
            <div *ngFor="let qa of data?.assignedQas" class="content-wrap"
                 [ngClass]="{'inActiveGroup': qa?.isActive === false || qa?.isTerminated === true}">
              {{ qa?.name }}
            </div>
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Assigned Doc Control(s)</div>
          <div *ngFor="let docControl of data?.assignedDocControls" class="content-wrap"
               [ngClass]="{'inActiveGroup': docControl?.isActive === false || docControl?.isTerminated === true}">
            {{ docControl?.name }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Reviewer(s)</div>
          <div *ngFor="let reviewer of data?.reviewersInformation" class="content-wrap"
               [ngClass]="{'inActiveGroup': reviewer?.isTerminated === true}">
            {{ reviewer?.name }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Approver(s)</div>
          <div *ngFor="let approver of data?.approversInformation" class="content-wrap"
               [ngClass]="{'inActiveGroup': approver?.isTerminated === true}">
            {{ approver?.name }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Periodic Reviewer(s)</div>
          <div *ngFor="let periodicReviewer of data?.periodicReviewersInformation" class="content-wrap"
               [ngClass]="{'inActiveGroup': periodicReviewer?.isTerminated === true}">
            {{ periodicReviewer?.name }}
          </div>
        </div>
        <div class="col-fixed" style="width: 10%">
          <div class="font-semibold mb-1">Internal Client Contact(s)</div>
          <div *ngFor="let contact of data?.internalClientContacts" class="content-wrap"
               [ngClass]="{'inActiveGroup': contact?.isTerminated === true}">
            {{ contact?.name }}
          </div>
        </div>
      </div>

      <!-- Where Am I Used View -->
      <div class="grid" *ngIf="viewMode === 2">
        <div class="col-fixed" style="width: 20%">
          <div class="font-semibold mb-1">eQMS Scope(s)</div>
          <ul>
            <li class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">{{ scope }}</li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 25%">
          <div class="font-semibold mb-1">Curriculum(s)</div>
          <ul>
            <li class="content-wrap" *ngFor="let curriculum of data?.curriculums">
              <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline font-semibold">
                <b pTooltip="{{ curriculum?.curriculumScopeName }}">
                  <a style="cursor: pointer;" (click)="openCurriculum(curriculum?.curriculumScopeId)">{{ curriculum?.curriculumScopeName }}</a>
                </b>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 25%">
          <div class="font-semibold mb-1">Training Item Group(s)</div>
          <ul>
            <li class="content-wrap" *ngFor="let trainingItemGroup of data?.trainingGroups">
              <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline font-semibold">
                <b pTooltip="{{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}">
                  <a style="cursor: pointer;" (click)="openTrainingItemGroup(trainingItemGroup?.trainingItemGroupNumber)">
                    {{ trainingItemGroup?.trainingItemGroupNumber }} {{ trainingItemGroup?.trainingItemGroupName }}
                  </a>
                </b>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-fixed" style="width: 25%">
          <div class="font-semibold mb-1">Related Document(s)</div>
          <ul>
            <li class="content-wrap" *ngFor="let relatedDocument of data?.relatedDocuments">
              <div class="blue-color cursor-pointer overflow-ellipse flex-initial flex underline font-semibold">
                <b pTooltip="{{ relatedDocument?.relatedDocumentNumber }} {{ relatedDocument?.relatedDocumentTitle }}">
                  <a style="cursor: pointer;" (click)="openDocument(relatedDocument?.relatedDocumentNumber, relatedDocument?.relatedDocumentVersion?.toString())">
                    {{ relatedDocument?.relatedDocumentNumber }} 
                    {{ relatedDocument?.relatedDocumentTitle }}
                    <ng-container *ngIf="relatedDocument?.relatedDocumentType === 0">
                      (v{{ relatedDocument?.relatedDocumentVersion }})
                    </ng-container>
                  </a>
                </b>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ng-template>
  </app-panel-hub>
</div>

